import { http } from './http';

export interface ApiDocumentType {
	id: number;
	documentTypeName: string;
	documentTypeDescription?: string;
	documentTypeExtension?: string;
	documentTypeOCR?: boolean;

	// PascalCase variants as returned by some backend serializers
	DocumentTypeName?: string;
	DocumentTypeDescription?: string;
	DocumentTypeExtension?: string;
	DocumentTypeOCR?: boolean;
}

function normalize(d: any): ApiDocumentType {
	if (d.DocumentTypeName && !d.documentTypeName) d.documentTypeName = d.DocumentTypeName;
	if (d.DocumentTypeDescription && !d.documentTypeDescription) d.documentTypeDescription = d.DocumentTypeDescription;
	if (d.DocumentTypeExtension && !d.documentTypeExtension) d.documentTypeExtension = d.DocumentTypeExtension;
	if (typeof d.DocumentTypeOCR === 'boolean' && typeof d.documentTypeOCR !== 'boolean') d.documentTypeOCR = d.DocumentTypeOCR;
	return d as ApiDocumentType;
}
export async function getDocumentTypes(): Promise<ApiDocumentType[]> { const data = await http<any[]>('/api/documenttype'); return Array.isArray(data)? data.map(normalize):[]; }
export async function addDocumentType(dt: Omit<ApiDocumentType,'id'>): Promise<ApiDocumentType> { return normalize(await http('/api/documenttype',{method:'POST', json:dt})); }
export async function updateDocumentType(id:number, dt: Omit<ApiDocumentType,'id'>): Promise<void> { await http(`/api/documenttype/${id}`,{method:'PUT', json:dt}); }
export async function deleteDocumentType(id:number): Promise<void> { await http(`/api/documenttype/${id}`,{method:'DELETE'}); }
